import { render, staticRenderFns } from "./ML_old.vue?vue&type=template&id=a2ba9ed8"
import script from "./ML_old.vue?vue&type=script&lang=js"
export * from "./ML_old.vue?vue&type=script&lang=js"
import style0 from "./ML_old.vue?vue&type=style&index=0&id=a2ba9ed8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports